import styles from "./RadioField.module.css";
import Fieldset from "./Fieldset";
import PropTypes from "prop-types";

export default function RadioField({
  disabled,
  errorList = [],
  items,
  legendText,
  name,
  required = true,
}) {
  return (
    <Fieldset errorList={errorList}>
      <legend className={styles.legend}>{legendText}</legend>
      <div className={styles.radioInputList}>
        {items?.map((option, index) => {
          return (
            <label htmlFor={option} className={styles.RadioField} key={index}>
              <input
                required={required}
                type="radio"
                id={option}
                name={name}
                value={option}
                disabled={disabled}
              />
              {option}
            </label>
          );
        })}
      </div>
    </Fieldset>
  );
}

RadioField.propTypes = {
  disabled: PropTypes.bool,
  errorList: PropTypes.arrayOf(PropTypes.string),
  items: PropTypes.arrayOf(PropTypes.string),
  legendText: PropTypes.string,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
};
